/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getDictionaryValues } from '../fn/dictionary/get-dictionary-values';
import { GetDictionaryValues$Params } from '../fn/dictionary/get-dictionary-values';


/**
 * Dictionary lookup endpoints. Requires authentication.
 */
@Injectable({ providedIn: 'root' })
export class DictionaryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDictionaryValues()` */
  static readonly GetDictionaryValuesPath = '/dict';

  /**
   * Get dictionary values by types.
   *
   * Finds and returns the saved dictionary values
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDictionaryValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDictionaryValues$Response(params: GetDictionaryValues$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<string>;
}>> {
    const obs = getDictionaryValues(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get dictionary values by types.
   *
   * Finds and returns the saved dictionary values
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDictionaryValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDictionaryValues(params: GetDictionaryValues$Params, context?: HttpContext): Observable<{
[key: string]: Array<string>;
}> {
    const resp = this.getDictionaryValues$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<string>;
}>): {
[key: string]: Array<string>;
} => r.body)
    );
  }

}
